import { render, staticRenderFns } from "./VueInlineAlert.vue?vue&type=template&id=1011c013"
import script from "./VueInlineAlert.vue?vue&type=script&lang=js"
export * from "./VueInlineAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports